// ============================================================================
// Catálogo de visibilidade da tela de Detalhes do Projeto (por CARGO)
// ----------------------------------------------------------------------------
// A tela ProjectDetails é compartilhada entre Master e colaborador. Para o
// colaborador, o Master decide por CARGO o que aparece:
//   - CAMPOS/SEÇÕES (PD_FIELDS): visíveis por padrão; o Master pode OCULTAR.
//   - AÇÕES (PD_ACTIONS): ocultas por padrão; o Master pode LIBERAR.
//
// Config em `employee_types/<doc>.projectDetails`:
//   { hiddenFields: [fieldKey...], allowedActions: [actionKey...] }
//
// Para o Master, tudo é sempre visível/habilitado (a config só afeta colaborador).
// ============================================================================

// Campos da Coluna 1 (granularidade campo a campo) + seções das Colunas 2/3.
// Visíveis por padrão para o colaborador; o Master oculta os que quiser.
export const PD_FIELDS = [
  // Coluna 1 — Informações do Projeto (campo a campo)
  { key: "projectName", label: "Nome do Projeto", group: "Informações" },
  { key: "clientEmail", label: "E-mail do Cliente", group: "Informações" },
  { key: "clientName", label: "Nome do Cliente", group: "Informações" },
  { key: "nickname", label: "Apelido", group: "Informações" },
  { key: "sourceLanguage", label: "Língua de Origem", group: "Informações" },
  { key: "targetLanguage", label: "Língua de Destino", group: "Informações" },
  { key: "currencyConversion", label: "Conversão Monetária", group: "Informações" },
  { key: "certification", label: "Certificação", group: "Informações" },
  { key: "priority", label: "Prioridade", group: "Informações" },
  { key: "deadline", label: "Prazo", group: "Informações" },
  { key: "createdAt", label: "Data de Recebimento", group: "Informações" },
  { key: "collection", label: "Coleção", group: "Informações" },
  { key: "statusSection", label: "Status do Projeto/Tradução", group: "Informações" },
  // Coluna 2 — Financeiro (seções)
  { key: "paymentSection", label: "Pagamento (status, datas, reembolso, nota)", group: "Financeiro" },
  { key: "valuesSection", label: "Valores e resumo de páginas", group: "Financeiro" },
  // Coluna 3 — Arquivos (seção)
  { key: "filesSection", label: "Lista de Arquivos", group: "Arquivos" },
  // Cards auxiliares / histórico
  { key: "observations", label: "Observações do Cliente", group: "Extras" },
  { key: "history", label: "Histórico de Movimentações", group: "Extras" },
];

// Ações (botões/controles de master). Ocultas por padrão; o Master libera por cargo.
export const PD_ACTIONS = [
  { key: "editName", label: "Editar nome do projeto", group: "Edição" },
  { key: "editLanguages", label: "Editar línguas", group: "Edição" },
  { key: "editCurrency", label: "Editar conversão monetária", group: "Edição" },
  { key: "editPriority", label: "Editar prioridade", group: "Edição" },
  { key: "editDeadline", label: "Editar prazo", group: "Edição" },
  { key: "editCollection", label: "Editar coleção", group: "Edição" },
  { key: "changeProjectStatus", label: "Mudar status do projeto", group: "Status" },
  { key: "changePaymentStatus", label: "Mudar status de pagamento", group: "Status" },
  { key: "editTotalValue", label: "Editar valor total", group: "Financeiro" },
  { key: "savePaymentNote", label: "Salvar nota de pagamento", group: "Financeiro" },
  { key: "generatePaymentLink", label: "Gerar link de pagamento", group: "Financeiro" },
  { key: "deleteProject", label: "Excluir projeto", group: "Perigo" },
  { key: "deleteFile", label: "Excluir arquivo", group: "Perigo" },
  { key: "addFile", label: "Adicionar arquivo", group: "Arquivos" },
  { key: "certify", label: "Certificar", group: "Arquivos" },
  { key: "downloadCertified", label: "Baixar certificados", group: "Arquivos" },
  { key: "replaceVersion", label: "Trocar/substituir versão do arquivo (na etapa)", group: "Arquivos" },
  { key: "downloadBackup", label: "Baixar backup (projeto finalizado)", group: "Arquivos" },
  { key: "finalizeProject", label: "Marcar projeto como finalizado", group: "Arquivos" },
  { key: "releaseWithoutPayment", label: "Liberar arquivos ao cliente sem pagamento", group: "Arquivos" },
  { key: "editPages", label: "Editar páginas", group: "Arquivos" },
  { key: "viewPrivateNote", label: "Ver/editar Nota Privada do Master", group: "Master" },
  { key: "masterWorkflowActions", label: "Enviar p/ Aprovação · Criar Divergência", group: "Master" },
];

export const PD_FIELD_KEYS = PD_FIELDS.map((f) => f.key);
export const PD_ACTION_KEYS = PD_ACTIONS.map((a) => a.key);

// Agrupa itens por `group` preservando a ordem de aparição.
const groupByCategory = (arr) => {
  const out = [];
  const idx = {};
  arr.forEach((it) => {
    if (idx[it.group] === undefined) {
      idx[it.group] = out.length;
      out.push({ group: it.group, items: [] });
    }
    out[idx[it.group]].items.push(it);
  });
  return out;
};

export const PD_FIELD_GROUPS = groupByCategory(PD_FIELDS);
export const PD_ACTION_GROUPS = groupByCategory(PD_ACTIONS);

// Normaliza a config de um cargo (defensivo contra chaves inexistentes).
export const resolveProjectDetailsConfig = (cfg) => ({
  hiddenFields: Array.isArray(cfg?.hiddenFields)
    ? cfg.hiddenFields.filter((k) => PD_FIELD_KEYS.includes(k))
    : [],
  allowedActions: Array.isArray(cfg?.allowedActions)
    ? cfg.allowedActions.filter((k) => PD_ACTION_KEYS.includes(k))
    : [],
});
